import React, {
  useEffect,
  useState,
} from "react";
import { withTranslation } from "react-i18next";
import {
  connect, useDispatch
} from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import AvFieldSelect from "components/Common/AvFieldSelect";
import { makeWinnerAPI } from "apis/competitions";
import { showErrorNotification, showSuccessNotification } from "store/actions";

function CompetitionRewardModal(props) {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const dispatch = useDispatch();
  const maxReward = Number(props.values?.competitionDetails?.reward ?? 0);

  useEffect(() => {
    if (props.values?.customer?.logins.length > 0) {
      setAccounts(props.values?.customer?.logins);
    }
  }, [props.values?.customer?._id]);

  useEffect(() => {
    if (props.show) {
      setSubmitted(false);
      setLoading(false);
    }
  }, [props.show]);
  return (
    <React.Fragment >
      <Modal isOpen={props.show} toggle={props.toggleShowModal} centered={true}>
        <ModalHeader toggle={props.toggleShowModal} tag="h4">
          {props.t("Competition Reward")}
        </ModalHeader>
        <ModalBody >
          <AvForm
            className='p-4'
            onValidSubmit={async (e, v) => {
              if (submitted) return;
              setLoading(true);
              setSubmitted(true);
              try {
                const res = await makeWinnerAPI({
                  compId: props.values.competitionDetails._id,
                  winnerId: props.values.customer._id,
                  values: { ...v }
                });
                if (res.result) {
                  dispatch(showSuccessNotification(res.message));
                  setTimeout(() => {
                    window.location.reload();
                  }, 250);
                } else {
                  dispatch(showErrorNotification(res.message));
                  setLoading(false);
                  props.toggleShowModal();
                }
              } catch (err) {
                dispatch(showErrorNotification(props.t("Something went wrong, please try again.")));
              }
            }}
          >
            <AvFieldSelect
              name="rewardType"
              label="Reward Type"
              placeholder="Select Reward Type"
              options={[
                // {
                //   label:"Bonus",
                //   value: "BONUS" 
                // },
                {
                  label: "Deposit",
                  value: "DEPOSIT"
                },
                {
                  label: "Credit",
                  value: "CREDIT"
                }
              ]}
              validate={{ required:true }}
            >      
            </AvFieldSelect>
            <AvField
              name="rewardAmount"
              type="number"
              label="Reward Amount"
              value={props.values?.competitionDetails?.reward}
              max={maxReward}
              min={0}
              validate={{
                required: { 
                  value: true, 
                  errorMessage: props.t("Reward amount is required") 
                },
                max: {
                  value: maxReward,
                  errorMessage: props.t(`The competition reward is limited to ${maxReward} only.`)
                },
              }}
            ></AvField>
            <AvFieldSelect
              name="account"
              label="Trading Account"
              placeholder="Select Trading Account"
              options={accounts?.map((acc) => {
                return {
                  label: acc,
                  value: acc
                };
              })}
              validate={{ required:true }}
            >      
            </AvFieldSelect>
            <div className="d-flex align-items-center justify-content-center">
              {!submitted ? (<Button type="submit" className="text-center">
                Continue
              </Button>) : (
                <Button className="text-center" disabled={loading} >
                  {loading ? "Rewarding..." : "Continue"}
                </Button>
              )}
            </div>
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, null)(withTranslation()(CompetitionRewardModal));
